import { ExitingPersistence } from '@atlaskit/motion';
import React, { useCallback, useEffect, useState } from 'react';
import { useScrollLock } from '../../useScrollLock';
import { useIsMobile } from '../useIsMobile';
import { MobileFilterDialog } from './MobileFilterDialog';
import { ShowFiltersButton } from './ShowFiltersButton';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileFilters = _ref => {
  var _sortOptions$;
  let {
    filterDefinitions,
    filterOptions,
    selectedOptions,
    filterStatus,
    sortOptions,
    selectedSortOption,
    onSelectedOptionsChange,
    onSelectedSortOptionChange,
    onClearAllFilters,
    onApplyFilters,
    onCloseMobileDialog,
    useAtlassianAppsExperimentNewUI = false
  } = _ref;
  const isMobile = useIsMobile();
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  useEffect(() => {
    if (!isMobile) {
      setIsFilterDialogOpen(false);
    }
  }, [isMobile]);
  useScrollLock(isFilterDialogOpen);
  const handleShowFiltersClicked = useCallback(() => {
    setIsFilterDialogOpen(true);
  }, []);
  const handleCloseDialog = useCallback(() => {
    setIsFilterDialogOpen(false);
    onCloseMobileDialog === null || onCloseMobileDialog === void 0 ? void 0 : onCloseMobileDialog();
  }, [onCloseMobileDialog]);
  const handleApplyFiltersClick = useCallback(() => {
    onApplyFilters === null || onApplyFilters === void 0 ? void 0 : onApplyFilters();
    setIsFilterDialogOpen(false);
  }, [onApplyFilters]);
  const numberOfSelections = Object.values(selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : {}).reduce((acc, options) => acc + options.length, 0) + ((selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.value) === ((_sortOptions$ = sortOptions[0]) === null || _sortOptions$ === void 0 ? void 0 : _sortOptions$.value) ? 0 : 1);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShowFiltersButton, {
      enableSort: sortOptions.length > 0 && !useAtlassianAppsExperimentNewUI,
      numberOfSelections: numberOfSelections,
      onClick: handleShowFiltersClicked
    }), /*#__PURE__*/_jsx(ExitingPersistence, {
      appear: true,
      children: isFilterDialogOpen && /*#__PURE__*/_jsx(MobileFilterDialog, {
        filterDefinitions: filterDefinitions,
        filterOptions: filterOptions,
        selectedOptions: selectedOptions,
        sortOptions: useAtlassianAppsExperimentNewUI ? [] : sortOptions,
        selectedSortOption: selectedSortOption,
        filterStatus: filterStatus,
        onClose: handleCloseDialog,
        onSelectedOptionsChange: onSelectedOptionsChange,
        onSelectedSortOptionChange: onSelectedSortOptionChange,
        onClearAllFilters: onClearAllFilters,
        onApplyFilters: handleApplyFiltersClick
      })
    })]
  });
};